import { render, staticRenderFns } from "./OrdenCompraTableComponent.vue?vue&type=template&id=7351d4c7&"
import script from "./OrdenCompraTableComponent.vue?vue&type=script&lang=js&"
export * from "./OrdenCompraTableComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports